import { cn } from '@/lib/utils'

type ContainerProps = {
	className?: string
	id?: string
	children: React.ReactNode
	as?: React.ElementType | string
}

const Container = ({ className, children, id, as: As = 'section' }: ContainerProps) => {
	return (
		<As className={cn('relative', className)} id={id}>
			{children}
		</As>
	)
}

const BackgroundImage = ({ className, ...props }: React.ImgHTMLAttributes<HTMLImageElement>) => (
	<img className={cn('absolute inset-0 w-full h-full object-cover z-0', className)} {...props} />
)

const Content = ({ className, children }: Omit<ContainerProps, 'as'>) => {
	return <div className={cn('container mx-auto px-6 py-10 lg:py-[60px] lg:px-[60px]', className)}>{children}</div>
}

Container.Content = Content
Container.BackgroundImage = BackgroundImage

export { Container }
